import React, { useState, useEffect } from "react";
import DropDownNTS from "./dropdownSpan";
import "./newTestSeries.css";
import Swal from "sweetalert2";
import { API_BASE_URL } from "../../Config/Config";
import { useSelector, useDispatch } from "react-redux";

const NewTestSeries = (dataClient) => {
  const [courses, setCourses] = useState([]);
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const [selectedClassId, setSelectedClassId] = useState(null);
  const [selectedSubjectId, setSelectedSubjectId] = useState(null);
  const [selectedTestId, setTestID] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [time, setTime] = useState("");
  const [timeMinutes, setTimeMinutes] = useState("");
  const [selectedSchemeId, setSelectedSchemeId] = useState(null);
  const [markingSchemes, setMarkingSchemes] = useState([]);
  const [selectedTest, setSelectedTest] = useState(null);
  const [seriesName, setSeriesName] = useState("");
  const [description, setDescription] = useState("");
  const [totalQuestions, setTotalQuestions] = useState("");
  const user_name = dataClient?.dataClient?.client_schema_name[6][0].user_name;
  const clientBranchId =
    dataClient.dataClient?.client_schema_name[6][0].client_branch_id;
  const clientId = dataClient.dataClient?.client_schema_name[6][0].client_id;
  const [subjectDetails, setSubjectDetails] = useState([]);

  const handleInputChange = (e) => {
    const minutes = e.target.value;
    const hours = (minutes / 60).toFixed(2);
    setTime(hours);
    setTimeMinutes(minutes);
  };
  useEffect(() => {
    fetch(
      // "https://quality.dse-cc-api.com/coaching-collaborator-api/api/v1/get-courses/"
      `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-courses/`
    )
      .then((response) => response.json())
      .then((data) => setCourses(data))
      .catch((error) => console.error("Error:", error));

    fetch(
      // "https://quality.dse-cc-api.com/coaching-collaborator-api/api/v1/get-classes/"
      `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-classes/`
    )
      .then((response) => response.json())
      .then((data) => setClasses(data))
      .catch((error) => console.error("Error:", error));
  }, []);
  useEffect(() => {
    if (selectedCourseId) {
      fetch(
        // `https://quality.dse-cc-api.com/coaching-collaborator-api/api/v1/get-subjects-by-course/?course_id=${selectedCourseId}`
        `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-subjects-by-course/?course_id=${selectedCourseId}`
      )
        .then((response) => response.json())
        .then((data) => setSubjects(data))
        .catch((error) => console.error("Error:", error));
    }
  }, [selectedCourseId]);

  useEffect(() => {
    if (selectedCourseId) {
      fetch(
        `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-subjects-by-course/?course_id=${selectedCourseId}`
      )
        .then((response) => response.json())
        .then((data) => {
          setSubjects(data);
          // Update subjectDetails based on the fetched subjects data
          setSubjectDetails(
            data.map((subject) => ({
              subject_id: subject.subject_id,
              total_ques_count: 0, // Initialize as 0
              mandatory_count: 0, // Initialize as 0
              optional_attempt_count: 0, // Initialize as 0
              optional_total_count: 0, // Initialize as 0
              optional_numeric: 0, // Initialize as 0
            }))
          );
        })
        .catch((error) => console.error("Error:", error));
    }
  }, [selectedCourseId]);

  // useEffect(() => {
  //   if (selectedCourseId) {
  //     fetch(
  //       `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-subjects-by-course/?course_id=${selectedCourseId}`
  //     )
  //       .then((response) => response.json())
  //       .then((data) => {
  //         setSubjects(data);
  //         // Update subjectDetails based on the fetched subjects data
  //         setSubjectDetails(
  //           data.map((subject) => ({
  //             subject_id: subject.subject_id,
  //             total_ques_count: "",
  //             mandatory_count: "",
  //             optional_attempt_count: "",
  //             optional_total_count: "",
  //             optional_numeric: 0, // Initialize as 0
  //           }))
  //         );
  //       })
  //       .catch((error) => console.error("Error:", error));
  //   }
  // }, [selectedCourseId]);

  const [tableTotalQuestions, setTableTotalQuestions] = useState(0);

  // const handleInputChangeInTable = (index, field, value) => {
  //   const newSubjectDetails = [...subjectDetails];
  //   if (field === "optional_numeric") {
  //     newSubjectDetails[index][field] = value ? parseInt(value) : 0;
  //   } else {
  //     newSubjectDetails[index][field] = value;
  //   }
  //   setSubjectDetails(newSubjectDetails);

  //   // If the field is 'total_ques_count', update the total questions
  //   if (field === "total_ques_count") {
  //     const total = newSubjectDetails.reduce(
  //       (sum, detail) => sum + (parseInt(detail.total_ques_count) || 0),
  //       0
  //     );
  //     setTableTotalQuestions(total);
  //   }
  // };
  const handleInputChangeInTable = (index, field, value) => {
    const newSubjectDetails = [...subjectDetails];
    if (field === "optional_attempt_count") {
      newSubjectDetails[index][field] = parseInt(value) || 0;
    } else {
      newSubjectDetails[index][field] = value;
    }
    setSubjectDetails(newSubjectDetails);

    if (field === "total_ques_count") {
      const total = newSubjectDetails.reduce(
        (sum, detail) => sum + (parseInt(detail.total_ques_count) || 0),
        0
      );
      setTableTotalQuestions(total);
    }
  };

  // In your render method, calculate the border color based on the total questions
  const borderColor =
    totalQuestions !== tableTotalQuestions ? "input-details-nts" : "black";
  const handleCancel = () => {
    Swal.fire({
      title: "Are you sure you want to cancel?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonColor: "rgb(100 101 101)",
      cancelButtonColor: "#318682",
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload();
      }
    });
  };
  const validateInput = (subjectDetailsInt) => {
    for (let detail of subjectDetailsInt) {
      if (
        !(
          detail.optional_total_count === 0 ||
          detail.optional_total_count === "" ||
          detail.optional_attempt_count < detail.optional_total_count
        ) &&
        detail.mandatory_count + detail.optional_total_count ==
          detail.total_ques_count
      ) {
        return false;
      }
    }
    return true;
  };

  useEffect(() => {
    fetch(
      `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-marking-scheme-list-active/`
    )
      .then((response) => response.json())
      .then((data) => setMarkingSchemes(data.data))
      .catch((error) => console.error("Error:", error));
  }, []);

  const handleSave = () => {
    if (subjectDetails.length === 0) {
      Swal.fire({
        title: "No Input Data",
        text: "Please provide some subject details.",
        icon: "error",
        confirmButtonText: "OK",
        confirmButtonColor: "rgb(100 101 101)",
      });
      return;
    }
    // Convert the values to integers
    const subjectDetailsInt = subjectDetails.map((detail) => ({
      ...detail,
      total_ques_count: parseInt(detail.total_ques_count),
      mandatory_count: parseInt(detail.mandatory_count),
      optional_attempt_count: parseInt(detail.optional_attempt_count),
      optional_total_count: parseInt(detail.optional_total_count),
      optional_numeric: parseInt(detail.optional_numeric),
    }));

    // Add the new validation here
    console.log(totalQuestions, tableTotalQuestions);
    if (parseInt(totalQuestions) !== tableTotalQuestions) {
      Swal.fire({
        title: "Input Error",
        text: "The total number of questions does not match the sum of subject-wise questions.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    if (!validateInput(subjectDetailsInt)) {
      Swal.fire({
        title: "Input Error",
        text: "Please check your input values.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }
    // Construct the URL with the selected values
    const url = `${API_BASE_URL}/coaching-collaborator-api/api/v1/test-series?series_name=${seriesName}&description=${description}&course_id=${selectedCourseId}&class_id=${selectedClassId}&ms_id=${selectedSchemeId}&duration_mins=${timeMinutes}&total_questions=${totalQuestions}&test_mode_id=${selectedTestId}&user_name=${user_name}&client_id=${clientId}&client_branch_id=${clientBranchId}`;

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(subjectDetailsInt),
    })
      .then((response) => response.json())
      .then((data) => {
        // Handle response data
        console.log(data);

        // Add Swal.fire here
        Swal.fire({
          title: "Test Series Created Successfully",
          icon: "success",
          timer: 2000, // 2 seconds
          confirmButtonColor: "#318682", // This will change the "OK" button color
        }).then(() => {
          setTimeout(function () {
            window.location.reload();
          }, 100);
        });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  return (
    <div
      style={{
        height: "auto",
        width: "100%",
        paddingLeft: "20px",
        marginBottom: "40px",
      }}
    >
      <div className="container-UP" style={{ position: "sticky", top: "0" }}>
        <div className="Header-up">
          <p className="title-cb">Create New Test Series</p>
          <div className="mb-2-UP">
            <button className="cr-cancel-btn me-cs4" onClick={handleCancel}>
              CANCEL
            </button>
            <button className="cr-create-btn" onClick={handleSave}>
              SAVE
            </button>
          </div>
        </div>
        <hr
          style={{
            color: "red",
            backgroundColor: "red",
            marginTop: "5px",
          }}
        />
      </div>
      <div className="container-cs-fluid ms-cs3 mt-cs3">
        <div className="card-cs1 card-border-CR">
          <div className="basic-info-color  transparent-margin-left transparent-margin-all ">
            SET SERIES
          </div>
          <div className=" transparent-margin-left grey-div-cs">
            <div className="row-cs-uni">
              <div className="col-cs">
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ width: "28%" }}>Name</div>

                  <input
                    type="text"
                    style={{
                      width: "50%",
                      marginTop: "10px",
                      marginLeft: "10px",
                      marginBottom: "5px",
                      height: "30px",
                      padding: "10px",
                      outline: "none",
                      color: "#6a6a6a",
                    }}
                    value={seriesName}
                    onChange={(e) => setSeriesName(e.target.value)}
                  />
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ width: "28%" }}>Course</div>
                  {/* <DropDownNTS
                    style={{
                      width: "50%",
                      marginTop: "5px",
                      marginLeft: "10px",
                    }}
                    selected={selectedCourseId}
                    setSelected={setSelectedCourseId}
                    options={courses.map((course) => ({
                      id: course.course_id,
                      label: course.course_name,
                    }))}
                  /> */}
                  <DropDownNTS
                    style={{
                      width: "50%",
                      marginTop: "5px",
                      marginLeft: "10px",
                      color: "#6a6a6a",
                    }}
                    selected={selectedCourseId}
                    setSelected={(value) => {
                      setSelectedCourseId(value);
                      const newSubjectDetails = subjectDetails.map(
                        (detail) => ({
                          ...detail,
                          optional_numeric:
                            value === 2 ? detail.optional_numeric : 0, //
                        })
                      );
                      setSubjectDetails(newSubjectDetails);
                    }}
                    options={courses.map((course) => ({
                      id: course.course_id,
                      label: course.course_name,
                    }))}
                  />
                </div>

                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ width: "28%" }}>Marking Scheme</div>
                  <DropDownNTS
                    style={{
                      width: "50%",
                      marginTop: "5px",
                      marginLeft: "10px",
                      marginBottom: "10px",
                    }}
                    selected={selectedSchemeId}
                    setSelected={setSelectedSchemeId}
                    options={markingSchemes.map((scheme) => ({
                      id: scheme.ms_id,
                      label: scheme.ms_name,
                    }))}
                  />
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ width: "28%" }}>Total Questions</div>
                  <input
                    type="number"
                    style={{
                      width: "50%",
                      marginLeft: "10px",
                      marginBottom: "10px",
                      height: "30px",
                      padding: "10px",
                      outline: "none",
                      color: "#6a6a6a",
                    }}
                    value={totalQuestions}
                    onChange={(e) => setTotalQuestions(e.target.value)}
                  />
                </div>
              </div>

              <div className="col-cs">
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ width: "28%" }}>Description</div>

                  <input
                    type="text"
                    style={{
                      width: "50%",
                      marginTop: "10px",
                      marginLeft: "10px",
                      marginBottom: "5px",
                      height: "30px",
                      padding: "10px",
                      outline: "none",
                      color: "#6a6a6a",
                    }}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ width: "28%" }}>Class</div>
                  <DropDownNTS
                    style={{
                      width: "50%",
                      marginTop: "5px",
                      marginLeft: "10px",
                      color: "#6a6a6a",
                    }}
                    selected={selectedClassId}
                    setSelected={setSelectedClassId}
                    options={classes.map((cls) => ({
                      id: cls.class_id,
                      label: cls.class_name,
                    }))}
                  />
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ width: "28%" }}>Test Mode</div>
                  <DropDownNTS
                    style={{
                      width: "50%",
                      marginTop: "5px",
                      marginLeft: "10px",
                      marginBottom: "10px",
                      color: "#6a6a6a",
                    }}
                    selected={selectedTest}
                    setSelected={(value) => {
                      setSelectedTest(value);
                      setTestID(value); // Update selectedTestId when the dropdown value changes
                    }}
                    options={[
                      { id: 1, label: "Online" },
                      { id: 2, label: "Offline" },
                      { id: 3, label: "Hybrid" },
                    ]}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <div style={{ width: "28%" }}>Duration</div>
                  <input
                    placeholder="( In minutes )"
                    type="number"
                    className="time-input"
                    onChange={handleInputChange}
                  />
                  <div className="time-display">{time} hr</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card-cs1 card-border-CR " style={{ marginTop: "20px" }}>
          <div className="basic-info-color  transparent-margin-left transparent-margin-all ">
            TEST SERIES DETAILS
          </div>
          <div className="" style={{ padding: "10px" }}>
            <table className="table-set-nts">
              <tr>
                <th className="cell-details">Subject</th>
                <th className="cell-details">No. of Questions</th>
                <th className="cell-details">Mandatory Count</th>
                <th className="cell-details" colspan="3">
                  Optional
                </th>
              </tr>
              <tr>
                <th className="blank-cell-details"></th>
                <th className="blank-cell-details"></th>
                <th className="blank-cell-details"></th>
                <th className="cell-details">Min. Attempt</th>
                <th className="cell-details">Optional Count</th>
                <th className="cell-details">Numeric?</th>
              </tr>
              {subjects.map((subject, index) => (
                <tr key={subject.subject_id}>
                  <td className="subjects-details">{subject.subject_name}</td>
                  <td>
                    <input
                      className="input-details-nts"
                      type="text"
                      value={subjectDetails[index]?.total_ques_count || ""}
                      onChange={(e) =>
                        handleInputChangeInTable(
                          index,
                          "total_ques_count",
                          e.target.value
                        )
                      }
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      className="input-details-nts"
                      value={subjectDetails[index]?.mandatory_count || ""}
                      onChange={(e) =>
                        handleInputChangeInTable(
                          index,
                          "mandatory_count",
                          e.target.value
                        )
                      }
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      className="input-details-nts"
                      value={
                        subjectDetails[index]?.optional_attempt_count || ""
                      }
                      onChange={(e) =>
                        handleInputChangeInTable(
                          index,
                          "optional_attempt_count",
                          e.target.value
                        )
                      }
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      className="input-details-nts"
                      value={subjectDetails[index]?.optional_total_count || ""}
                      onChange={(e) =>
                        handleInputChangeInTable(
                          index,
                          "optional_total_count",
                          e.target.value
                        )
                      }
                    />
                  </td>
                  <td>
                    <select
                      className="input-details-nts-2"
                      name="Numeric"
                      id="Numeric"
                      value={subjectDetails[index]?.optional_numeric || ""}
                      onChange={(e) =>
                        handleInputChangeInTable(
                          index,
                          "optional_numeric",
                          e.target.value
                        )
                      }
                      disabled={selectedCourseId !== 2}
                    >
                      <option value="0">No</option>
                      <option value="1">Yes</option>
                    </select>
                  </td>
                </tr>
              ))}
            </table>
            <div
              className="total-questions-nts"
              style={{ border: `1px solid ${borderColor}` }}
            >
              Total Questions : {tableTotalQuestions}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewTestSeries;
